var _style, _g, _polygon, _polygon2, _polygon3, _polygon4, _defs, _polygon5, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _polygon6, _path, _path2, _circle, _circle2, _defs2, _rect, _rect2, _circle3, _circle4, _defs3, _rect3, _rect4, _circle5, _circle6, _defs4, _rect5, _rect6, _circle7, _circle8, _defs5, _rect7, _rect8, _circle9, _circle10, _defs6, _rect9, _rect10, _path3, _defs7, _path4, _path5, _defs8, _path6, _path7, _defs9, _path8, _path9, _defs10, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _polygon7, _path10, _g2, _polygon8, _polygon9, _polygon10, _polygon11, _defs11, _polygon12, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _polygon13, _path11, _path12, _circle11, _circle12, _defs12, _rect11, _rect12, _circle13, _circle14, _defs13, _rect13, _rect14, _circle15, _circle16, _defs14, _rect15, _rect16, _circle17, _circle18, _defs15, _rect17, _rect18, _circle19, _circle20, _defs16, _rect19, _rect20, _path13, _defs17, _path14, _path15, _defs18, _path16, _path17, _defs19, _path18, _path19, _defs20, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _polygon14, _path20, _g3, _polygon15, _polygon16, _polygon17, _polygon18, _defs21, _polygon19, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _polygon20, _path21, _path22, _circle21, _circle22, _defs22, _rect21, _rect22, _circle23, _circle24, _defs23, _rect23, _rect24, _circle25, _circle26, _defs24, _rect25, _rect26, _circle27, _circle28, _defs25, _rect27, _rect28, _circle29, _circle30, _defs26, _rect29, _rect30, _path23, _defs27, _path24, _path25, _defs28, _path26, _path27, _defs29, _path28, _path29, _defs30, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _polygon21, _path30, _g4, _polygon22, _polygon23, _polygon24, _polygon25, _defs31, _polygon26, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _polygon27, _path31, _path32, _circle31, _circle32, _defs32, _rect31, _rect32, _circle33, _circle34, _defs33, _rect33, _rect34, _circle35, _circle36, _defs34, _rect35, _rect36, _circle37, _circle38, _defs35, _rect37, _rect38, _circle39, _circle40, _defs36, _rect39, _rect40, _path33, _defs37, _path34, _path35, _defs38, _path36, _path37, _defs39, _path38, _path39, _defs40, _line77, _line78, _line79, _line80, _line81, _line82, _line83, _line84, _polygon28, _path40, _g5, _polygon29, _polygon30, _polygon31, _polygon32, _defs41, _polygon33, _line85, _line86, _line87, _line88, _line89, _line90, _line91, _line92, _line93, _line94, _line95, _line96, _line97, _polygon34, _path41, _path42, _circle41, _circle42, _defs42, _rect41, _rect42, _circle43, _circle44, _defs43, _rect43, _rect44, _circle45, _circle46, _defs44, _rect45, _rect46, _circle47, _circle48, _defs45, _rect47, _rect48, _circle49, _circle50, _defs46, _rect49, _rect50, _path43, _defs47, _path44, _path45, _defs48, _path46, _path47, _defs49, _path48, _path49, _defs50, _line98, _line99, _line100, _line101, _line102, _line103, _line104, _line105, _polygon35, _path50, _g6, _polygon36, _polygon37, _polygon38, _polygon39, _defs51, _polygon40, _line106, _line107, _line108, _line109, _line110, _line111, _line112, _line113, _line114, _line115, _line116, _line117, _line118, _polygon41, _path51, _path52, _circle51, _circle52, _defs52, _rect51, _rect52, _circle53, _circle54, _defs53, _rect53, _rect54, _circle55, _circle56, _defs54, _rect55, _rect56, _circle57, _circle58, _defs55, _rect57, _rect58, _circle59, _circle60, _defs56, _rect59, _rect60, _path53, _defs57, _path54, _path55, _defs58, _path56, _path57, _defs59, _path58, _path59, _defs60, _line119, _line120, _line121, _line122, _line123, _line124, _line125, _line126, _polygon42, _path60, _g7, _polygon43, _polygon44, _polygon45, _polygon46, _defs61, _polygon47, _line127, _line128, _line129, _line130, _line131, _line132, _line133, _line134, _line135, _line136, _line137, _line138, _line139, _polygon48, _path61, _path62, _circle61, _circle62, _defs62, _rect61, _rect62, _circle63, _circle64, _defs63, _rect63, _rect64, _circle65, _circle66, _defs64, _rect65, _rect66, _circle67, _circle68, _defs65, _rect67, _rect68, _circle69, _circle70, _defs66, _rect69, _rect70, _path63, _defs67, _path64, _path65, _defs68, _path66, _path67, _defs69, _path68, _path69, _defs70, _line140, _line141, _line142, _line143, _line144, _line145, _line146, _line147, _polygon49, _path70, _g8, _polygon50, _polygon51, _polygon52, _polygon53, _defs71, _polygon54, _line148, _line149, _line150, _line151, _line152, _line153, _line154, _line155, _line156, _line157, _line158, _line159, _line160, _polygon55, _path71, _path72, _circle71, _circle72, _defs72, _rect71, _rect72, _circle73, _circle74, _defs73, _rect73, _rect74, _circle75, _circle76, _defs74, _rect75, _rect76, _circle77, _circle78, _defs75, _rect77, _rect78, _circle79, _circle80, _defs76, _rect79, _rect80, _path73, _defs77, _path74, _path75, _defs78, _path76, _path77, _defs79, _path78, _path79, _defs80, _line161, _line162, _line163, _line164, _line165, _line166, _line167, _line168, _polygon56, _path80;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCause1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 222.1 220.8",
    style: {
      enableBackground: "new 0 0 222.1 220.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#A57E71;}\n\t.st1{fill:#F2DAD1;}\n\t.st2{fill:#DEB5A1;}\n\t.st3{fill:#383838;}\n\t.st4{fill:#9DD2C9;}\n\t.st5{clip-path:url(#SVGID_00000078748180195739927040000008463323726417218691_);}\n\t.st6{fill:#26A58C;}\n\t.st7{fill:none;stroke:#000000;stroke-width:2.3;stroke-miterlimit:10;}\n\t.st8{fill:#A0A0A0;}\n\t.st9{fill:#BC4055;}\n\t.st10{fill:#F09EA5;}\n\t.st11{clip-path:url(#SVGID_00000024698354621537629860000005259069213107459752_);}\n\t.st12{fill:#FFFFFF;}\n\t.st13{clip-path:url(#SVGID_00000072268416627494347190000015311862598499062199_);}\n\t.st14{clip-path:url(#SVGID_00000003068059951377932130000002352313712677797282_);}\n\t.st15{clip-path:url(#SVGID_00000050623612953523634790000014441759707246209703_);}\n\t.st16{clip-path:url(#SVGID_00000097488154339732897530000016161004928423467680_);}\n\t.st17{fill:#96CCC3;}\n\t.st18{clip-path:url(#SVGID_00000024716102223411021940000000106081136572031415_);}\n\t.st19{clip-path:url(#SVGID_00000055689503491798395320000014409715389555083703_);}\n\t.st20{fill:#BCBCBC;}\n\t.st21{clip-path:url(#SVGID_00000123431698598375627470000016027693993920581301_);}\n\t.st22{fill:#A3233E;}\n\t.st23{fill:#D67296;}\n\t.st24{clip-path:url(#SVGID_00000074405992132915278110000005573465625752789423_);}\n\t.st25{fill:none;stroke:#000000;stroke-width:1.12;stroke-miterlimit:10;}\n\t.st26{fill:#8BD6C9;}\n\t.st27{clip-path:url(#SVGID_00000042703600878995205210000012497144333732170668_);}\n\t.st28{clip-path:url(#SVGID_00000078756780180791007120000004319433075182066576_);}\n\t.st29{clip-path:url(#SVGID_00000170265831226146689690000011822265066040204190_);}\n\t.st30{clip-path:url(#SVGID_00000143613222921635197430000016826394155682227861_);}\n\t.st31{clip-path:url(#SVGID_00000139986314627915961740000017014760433361482388_);}\n\t.st32{clip-path:url(#SVGID_00000069383065414068861790000014658497257298086574_);}\n\t.st33{clip-path:url(#SVGID_00000047742013708742854080000016160089633183746973_);}\n\t.st34{clip-path:url(#SVGID_00000176744378683219179180000006636372720630912410_);}\n\t.st35{clip-path:url(#SVGID_00000155133470085464010860000008456619029723231371_);}\n\t.st36{clip-path:url(#SVGID_00000057106354637949274070000008266310276215764121_);}\n\t.st37{clip-path:url(#SVGID_00000095331856272566800690000008805188886801716116_);}\n\t.st38{clip-path:url(#SVGID_00000107549150561517787290000010947676416833585026_);}\n\t.st39{clip-path:url(#SVGID_00000147940661311294719940000007528471674359467175_);}\n\t.st40{clip-path:url(#SVGID_00000073723695771497110750000013130483169461600898_);}\n\t.st41{clip-path:url(#SVGID_00000009572526611690432360000010930733200359592853_);}\n\t.st42{clip-path:url(#SVGID_00000043455887436032472060000011640473647502772152_);}\n\t.st43{clip-path:url(#SVGID_00000037670034904770067360000004139611000839333551_);}\n\t.st44{clip-path:url(#SVGID_00000145753127159226251500000008654912293550703293_);}\n\t.st45{clip-path:url(#SVGID_00000003814802823555399990000011979065885630507653_);}\n\t.st46{clip-path:url(#SVGID_00000052796759230839886880000010993552336439567528_);}\n\t.st47{clip-path:url(#SVGID_00000157988021100004913890000007308275451380951975_);}\n\t.st48{clip-path:url(#SVGID_00000029004286885424176550000007498330390194908305_);}\n\t.st49{clip-path:url(#SVGID_00000132077424266412746620000014968165574886483861_);}\n\t.st50{clip-path:url(#SVGID_00000083773617875085077950000016918841115898460834_);}\n\t.st51{clip-path:url(#SVGID_00000147923274662685455860000008458954938725375643_);}\n\t.st52{clip-path:url(#SVGID_00000077285657274441707260000004996189115758120378_);}\n\t.st53{clip-path:url(#SVGID_00000080897354490119624950000018113480747802930861_);}\n\t.st54{clip-path:url(#SVGID_00000021099078353333151620000005367970176865007023_);}\n\t.st55{clip-path:url(#SVGID_00000074437680770337605040000017394245621315020702_);}\n\t.st56{clip-path:url(#SVGID_00000181775388217154160180000011312586464223236017_);}\n\t.st57{clip-path:url(#SVGID_00000120532392410137161730000001847574372144932796_);}\n\t.st58{clip-path:url(#SVGID_00000043419113297456331400000003369271255611046025_);}\n\t.st59{clip-path:url(#SVGID_00000003105232567017312520000004501402464936797831_);}\n\t.st60{clip-path:url(#SVGID_00000000184383730144971160000012493123608121124749_);}\n\t.st61{clip-path:url(#SVGID_00000085214909857351029360000013558069979042735263_);}\n\t.st62{clip-path:url(#SVGID_00000072995447538200052680000017164589566723681969_);}\n\t.st63{clip-path:url(#SVGID_00000044153551427411195340000004605253190709562296_);}\n\t.st64{clip-path:url(#SVGID_00000181766840614591397160000016513994011381229473_);}\n\t.st65{clip-path:url(#SVGID_00000116193482149885577240000006122064931748688304_);}\n\t.st66{clip-path:url(#SVGID_00000026147056921937895850000003848036423084074912_);}\n\t.st67{clip-path:url(#SVGID_00000170982937498585967970000012184153896495917709_);}\n\t.st68{clip-path:url(#SVGID_00000144308382476569810680000001346913114635930518_);}\n\t.st69{clip-path:url(#SVGID_00000003064329061698115110000007044065097205594790_);}\n\t.st70{clip-path:url(#SVGID_00000165942928254725138000000007477977724142625664_);}\n\t.st71{clip-path:url(#SVGID_00000181794752907344989170000008767943636751787687_);}\n\t.st72{clip-path:url(#SVGID_00000125564163107774274270000015597576121310513543_);}\n\t.st73{clip-path:url(#SVGID_00000159444991015070292220000014772131773418047934_);}\n\t.st74{clip-path:url(#SVGID_00000109016934082824708670000004997847056403782564_);}\n\t.st75{clip-path:url(#SVGID_00000042716077256789172840000008115427660432602032_);}\n\t.st76{clip-path:url(#SVGID_00000063626848330503107080000001967815453317183893_);}\n\t.st77{clip-path:url(#SVGID_00000014595470042613295460000003835732713518773120_);}\n\t.st78{clip-path:url(#SVGID_00000006686354296242320360000007917921985232120988_);}\n\t.st79{clip-path:url(#SVGID_00000065779101798293709750000015414063850166614968_);}\n\t.st80{clip-path:url(#SVGID_00000001630522185798408930000013639854889580593071_);}\n\t.st81{clip-path:url(#SVGID_00000065756983916761259260000003824876065576709811_);}\n\t.st82{clip-path:url(#SVGID_00000075151835170395919050000006409654497308782998_);}\n\t.st83{clip-path:url(#SVGID_00000030463551013265306690000013227400758837708726_);}\n\t.st84{clip-path:url(#SVGID_00000014613039680178798240000010127993751903204992_);}\n\t.st85{clip-path:url(#SVGID_00000111893808310740889920000001709481829108237232_);}\n\t.st86{clip-path:url(#SVGID_00000182494127978172961940000000888260951241171350_);}\n\t.st87{clip-path:url(#SVGID_00000127033491219186469590000002594084413248222617_);}\n\t.st88{clip-path:url(#SVGID_00000173859633621281739740000009655773785566670264_);}\n\t.st89{clip-path:url(#SVGID_00000066484895742539323070000009369815300022029496_);}\n\t.st90{clip-path:url(#SVGID_00000114761756169378355900000003069574264988427954_);}\n\t.st91{clip-path:url(#SVGID_00000114782597736368035520000008861273350311642014_);}\n\t.st92{clip-path:url(#SVGID_00000091731906812240100770000007453265427244763060_);}\n\t.st93{clip-path:url(#SVGID_00000017496890016603069320000002182495458863851155_);}\n\t.st94{clip-path:url(#SVGID_00000160164638995704288500000004960979749423758979_);}\n\t.st95{clip-path:url(#SVGID_00000099663750916346382710000001368317274331255987_);}\n\t.st96{clip-path:url(#SVGID_00000043454908430446122580000000486740334642178437_);}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000164516197089665792620000001143140475078660514_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000116944488812351522120000002144450211647226024_"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pansements"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue"
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_1_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000083783505484391520860000003430789526638113941_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000083783505484391520860000003430789526638113941_)"
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000103240585844263365990000013037297787023349172_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000151523942441274558920000013382566215957129897_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000103240585844263365990000013037297787023349172_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000151523942441274558920000013382566215957129897_)"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000066474214247989353120000015771484426458636991_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000130625067882771527210000003646701567846245281_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000066474214247989353120000015771484426458636991_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000130625067882771527210000003646701567846245281_)"
    }
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000130630375314671993170000006549323267675895951_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152966468043331036420000002314449965906905509_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130630375314671993170000006549323267675895951_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152966468043331036420000002314449965906905509_)"
    }
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000014621847127053605650000008679019663989576577_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000105394774000876059830000013132208711225097645_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000014621847127053605650000008679019663989576577_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000105394774000876059830000013132208711225097645_)"
    }
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000069394742911460229020000016299587390916667312_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043447483917046400540000014700657345486444715_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069394742911460229020000016299587390916667312_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043447483917046400540000014700657345486444715_)"
    }
  }, _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000183952571235007724140000002243490888303840650_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016069089127821096000000009859444119041101198_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000183952571235007724140000002243490888303840650_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016069089127821096000000009859444119041101198_)"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000067930688516075227540000014132484109581253545_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075874263746578092810000006163496977985826730_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000067930688516075227540000014132484109581253545_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075874263746578092810000006163496977985826730_)"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029030661346581016600000010904243533423819151_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000174600067235254475760000005300232767786970542_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029030661346581016600000010904243533423819151_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000174600067235254475760000005300232767786970542_)"
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000142170051928943379500000014058881133510957455_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000075147302308502178090000017978911350195432634_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000142170051928943379500000014058881133510957455_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000075147302308502178090000017978911350195432634_)"
    }
  }, _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000031928188535499894000000011956170823895752839_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "pansements_00000121971127230169961860000000712369115747802780_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue_00000057839233899325120160000017498867197450344625_"
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000005246774285384679950000017254047843189196188_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6  167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170967079702933977540000017857793319621121936_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005246774285384679950000017254047843189196188_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170967079702933977540000017857793319621121936_)"
    }
  }, _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000088097119109857501410000017497239747611936918_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000038388867128169640660000017776872072616627850_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088097119109857501410000017497239747611936918_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000038388867128169640660000017776872072616627850_)"
    }
  }, _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000166664623157954935220000014624222354512112824_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000131364418449745799310000010850936126930361003_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000166664623157954935220000014624222354512112824_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000131364418449745799310000010850936126930361003_)"
    }
  }, _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000129912201591704567800000005721845189933104300_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106862550232366077600000006728607268751803322_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129912201591704567800000005721845189933104300_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106862550232366077600000006728607268751803322_)"
    }
  }, _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000015318999696756424330000012493963004368292007_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000114754879943081813810000013880312379221601951_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000015318999696756424330000012493963004368292007_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000114754879943081813810000013880312379221601951_)"
    }
  }, _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000059288307558029187140000008917331378186805388_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000123405137137461508350000003987864780958893238_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000059288307558029187140000008917331378186805388_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000123405137137461508350000003987864780958893238_)"
    }
  }, _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000100343724859570470120000010437864376277640126_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000165915064031303952240000005123741304558512831_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000100343724859570470120000010437864376277640126_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000165915064031303952240000005123741304558512831_)"
    }
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000051375672824041916910000010519993291730869379_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003806680220634163060000012236626098107891612_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051375672824041916910000010519993291730869379_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003806680220634163060000012236626098107891612_)"
    }
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000052079803053531153880000015048971363821440392_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057864239739507204740000005839179427487338911_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000052079803053531153880000015048971363821440392_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057864239739507204740000005839179427487338911_)"
    }
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000106133837942073605940000000148124838903784337_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000013194033064241694160000006636570673337689220_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000106133837942073605940000000148124838903784337_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000013194033064241694160000006636570673337689220_)"
    }
  }, _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000080202190543463177360000000382956474912013737_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000033330116082761575230000002832330617184186042_"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "pansements_00000101819907955591678930000015824691609365528474_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue_00000124139768128083292170000003121081458239416243_"
  }, _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000039102428982802157960000012896349037810448526_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6  167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000046335634312081596380000005195630237608543872_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039102428982802157960000012896349037810448526_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000046335634312081596380000005195630237608543872_)"
    }
  }, _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000017516803259208419400000000712156468041566854_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145037345356481119960000000527308195661018778_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000017516803259208419400000000712156468041566854_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145037345356481119960000000527308195661018778_)"
    }
  }, _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000037662746400553776910000006885216945152665491_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000033334840257366062210000003646248224562868880_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037662746400553776910000006885216945152665491_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000033334840257366062210000003646248224562868880_)"
    }
  }, _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000063629571698106684410000001791937066360082581_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000118371249686382938280000011094898925393253289_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000063629571698106684410000001791937066360082581_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000118371249686382938280000011094898925393253289_)"
    }
  }, _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs25 || (_defs25 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000053540222624139218310000012515501060137069758_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000029734146874641272960000001928624048956163998_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053540222624139218310000012515501060137069758_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000029734146874641272960000001928624048956163998_)"
    }
  }, _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs26 || (_defs26 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000039091578096629505830000015094234789900922045_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000006687713656081601540000003984138665364040356_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039091578096629505830000015094234789900922045_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000006687713656081601540000003984138665364040356_)"
    }
  }, _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs27 || (_defs27 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000050636135878837847830000016504832901754581169_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000172415687534206956580000010260559936345926538_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000050636135878837847830000016504832901754581169_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000172415687534206956580000010260559936345926538_)"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs28 || (_defs28 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000170980996025201680690000012753933815543889332_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000093177709987161394380000013092945180156869271_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000170980996025201680690000012753933815543889332_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000093177709987161394380000013092945180156869271_)"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs29 || (_defs29 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000154412297340982363710000000260249668918631594_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106135032171557927600000001178942576909523381_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000154412297340982363710000000260249668918631594_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106135032171557927600000001178942576909523381_)"
    }
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs30 || (_defs30 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000087378046974708077800000010934699568421977001_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000089551931989069051320000003514481010571720378_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087378046974708077800000010934699568421977001_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000089551931989069051320000003514481010571720378_)"
    }
  }, _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000072966088711984494630000009650132427891089081_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000163755765036825508390000005969073792210388151_"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "pansements_00000017496286580791776330000003312259271056940454_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue_00000118359528613702803490000015261978608858997412_"
  }, _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs31 || (_defs31 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000081632745551349358400000003099743972513428639_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6  167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119829422571866118850000017316493984285225380_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000081632745551349358400000003099743972513428639_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119829422571866118850000017316493984285225380_)"
    }
  }, _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs32 || (_defs32 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000039118331789219311380000009424160508575999676_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070118522511242331330000007752462382682256525_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000039118331789219311380000009424160508575999676_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070118522511242331330000007752462382682256525_)"
    }
  }, _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs33 || (_defs33 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000053508462522148591200000006195957092811128254_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182498691138266491240000016583737566327517837_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000053508462522148591200000006195957092811128254_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182498691138266491240000016583737566327517837_)"
    }
  }, _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs34 || (_defs34 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000087373792235532835080000015345705765765122215_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000138538192814420884360000011049937076365149114_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000087373792235532835080000015345705765765122215_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000138538192814420884360000011049937076365149114_)"
    }
  }, _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs35 || (_defs35 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000048489839023087546050000012323426043489994171_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000009569238118587043200000011835962725502425217_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000048489839023087546050000012323426043489994171_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000009569238118587043200000011835962725502425217_)"
    }
  }, _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs36 || (_defs36 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000175280849514030384460000009821599522263708601_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000128472972743868402560000014288112699295199652_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175280849514030384460000009821599522263708601_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000128472972743868402560000014288112699295199652_)"
    }
  }, _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs37 || (_defs37 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000009566150741883076020000003863062020296036535_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000119797998849252686080000007634125968954088369_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000009566150741883076020000003863062020296036535_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000119797998849252686080000007634125968954088369_)"
    }
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs38 || (_defs38 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000077289996821129033240000009683843462426907018_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039814284091838687450000009115688536521942179_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000077289996821129033240000009683843462426907018_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039814284091838687450000009115688536521942179_)"
    }
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs39 || (_defs39 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000044143129567566122840000015038287515407712155_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000052084636568308428680000012523352356515238071_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000044143129567566122840000015038287515407712155_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000052084636568308428680000012523352356515238071_)"
    }
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs40 || (_defs40 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000093160377485821259670000015231482350867285668_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000132785893414922534000000002563537260619227550_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093160377485821259670000015231482350867285668_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000132785893414922534000000002563537260619227550_)"
    }
  }, _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line79 || (_line79 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line80 || (_line80 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line81 || (_line81 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line82 || (_line82 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line83 || (_line83 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line84 || (_line84 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000142888674190510500710000010379244269388357539_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000076572645382546604700000017757939462900617656_"
  }, _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "pansements_00000173856060546946219880000013637599694400596406_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue_00000119082662148893872840000002323073794333521538_"
  }, _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs41 || (_defs41 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000023240529941565918550000002707872367147583132_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6  167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000043447384076931270680000009844835936792155322_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023240529941565918550000002707872367147583132_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000043447384076931270680000009844835936792155322_)"
    }
  }, _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line85 || (_line85 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line86 || (_line86 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line87 || (_line87 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line88 || (_line88 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line89 || (_line89 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line90 || (_line90 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line91 || (_line91 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line92 || (_line92 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line93 || (_line93 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line94 || (_line94 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line95 || (_line95 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line96 || (_line96 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line97 || (_line97 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs42 || (_defs42 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000180336967850143317840000017212758601589660062_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000129194178938815536160000017909407754109946241_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000180336967850143317840000017212758601589660062_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000129194178938815536160000017909407754109946241_)"
    }
  }, _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs43 || (_defs43 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000088106038954823542910000006873730875561005952_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000070821192027318718990000012242415906991936187_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000088106038954823542910000006873730875561005952_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000070821192027318718990000012242415906991936187_)"
    }
  }, _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs44 || (_defs44 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000045580344144726755280000008045965569801849760_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074406116550185703610000000083973897061519290_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000045580344144726755280000008045965569801849760_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074406116550185703610000000083973897061519290_)"
    }
  }, _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs45 || (_defs45 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000182518595456680858130000014589046734307558059_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000137107973219490565820000004894938304865174713_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000182518595456680858130000014589046734307558059_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000137107973219490565820000004894938304865174713_)"
    }
  }, _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle49 || (_circle49 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle50 || (_circle50 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs46 || (_defs46 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000098929815864631405530000008767130375770893696_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000168089352527289558450000011316412667223377808_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000098929815864631405530000008767130375770893696_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000168089352527289558450000011316412667223377808_)"
    }
  }, _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs47 || (_defs47 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000051350486403007865760000001164060390648724910_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000045614360349981116300000013580814873839031718_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051350486403007865760000001164060390648724910_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000045614360349981116300000013580814873839031718_)"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs48 || (_defs48 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000005973219420983187630000014324805559891165335_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000152943030558733561780000015126008945876431764_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005973219420983187630000014324805559891165335_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000152943030558733561780000015126008945876431764_)"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs49 || (_defs49 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000123401166291979440510000015366003896100112000_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182499137004410081610000002166258311476620723_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123401166291979440510000015366003896100112000_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182499137004410081610000002166258311476620723_)"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs50 || (_defs50 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000006706638583670370530000001191159267262391428_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000073686279503260985230000002983735211490633884_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000006706638583670370530000001191159267262391428_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000073686279503260985230000002983735211490633884_)"
    }
  }, _line98 || (_line98 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line99 || (_line99 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line100 || (_line100 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line101 || (_line101 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line102 || (_line102 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line103 || (_line103 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line104 || (_line104 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line105 || (_line105 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000070809057855004730580000016222594829025428660_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000014629818062772413670000002121291310084024968_"
  }, _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "pansements_00000098199834927063086290000015913052664807439294_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue_00000142859797291456036750000011788182900772831112_"
  }, _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs51 || (_defs51 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000096049026092754036400000010671619210312016795_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6  167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057136430408381468160000006760514612155624868_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000096049026092754036400000010671619210312016795_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000057136430408381468160000006760514612155624868_)"
    }
  }, _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line106 || (_line106 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line107 || (_line107 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line108 || (_line108 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line109 || (_line109 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line110 || (_line110 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line111 || (_line111 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line112 || (_line112 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line113 || (_line113 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line114 || (_line114 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line115 || (_line115 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line116 || (_line116 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line117 || (_line117 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line118 || (_line118 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle51 || (_circle51 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle52 || (_circle52 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs52 || (_defs52 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000097465660053850547650000007499808506780294313_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000169556891516193792550000017560817659444286867_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000097465660053850547650000007499808506780294313_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000169556891516193792550000017560817659444286867_)"
    }
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle53 || (_circle53 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle54 || (_circle54 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs53 || (_defs53 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000069387396235311883620000001848151668354009246_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103228954268049162360000017276574089630281124_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000069387396235311883620000001848151668354009246_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103228954268049162360000017276574089630281124_)"
    }
  }, _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle55 || (_circle55 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle56 || (_circle56 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs54 || (_defs54 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000049936458149567038100000003291436207893886080_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000103235151462036674270000007878948247015960231_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000049936458149567038100000003291436207893886080_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000103235151462036674270000007878948247015960231_)"
    }
  }, _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle57 || (_circle57 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle58 || (_circle58 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs55 || (_defs55 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000047036542191540051960000012346701041676606884_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000183242240475743708350000015465849596970619577_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000047036542191540051960000012346701041676606884_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000183242240475743708350000015465849596970619577_)"
    }
  }, _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle59 || (_circle59 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle60 || (_circle60 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs56 || (_defs56 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000123430774635581731270000008446452357392137904_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000106847850601799184530000001505705517350567343_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000123430774635581731270000008446452357392137904_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000106847850601799184530000001505705517350567343_)"
    }
  }, _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs57 || (_defs57 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000111173006409543471220000004257346843577913496_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000182493065862824738300000002152257705960564640_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111173006409543471220000004257346843577913496_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000182493065862824738300000002152257705960564640_)"
    }
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs58 || (_defs58 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000148638473994900731820000000154090595619661465_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016047257833224495870000016749915566090927760_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000148638473994900731820000000154090595619661465_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000016047257833224495870000016749915566090927760_)"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs59 || (_defs59 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000054267796362682935550000011028430555448812476_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000175300704224079304620000001710007885328195996_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000054267796362682935550000011028430555448812476_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000175300704224079304620000001710007885328195996_)"
    }
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs60 || (_defs60 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000060011031949337778400000015684806930017966989_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000074407942976443180980000005153787324680241285_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000060011031949337778400000015684806930017966989_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000074407942976443180980000005153787324680241285_)"
    }
  }, _line119 || (_line119 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line120 || (_line120 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line121 || (_line121 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line122 || (_line122 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line123 || (_line123 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line124 || (_line124 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line125 || (_line125 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line126 || (_line126 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000001623028354052619320000003313365304680606884_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000033360501232763492670000005528995352836084367_"
  }, _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "pansements_00000040559436345684723360000006836411034825678504_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue_00000115515613283506902630000004278520626265514930_"
  }, _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs61 || (_defs61 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000172398863735454946010000005479189333483039364_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6  167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000012436458015414215770000000797353157732174471_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000172398863735454946010000005479189333483039364_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000012436458015414215770000000797353157732174471_)"
    }
  }, _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line127 || (_line127 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line128 || (_line128 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line129 || (_line129 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line130 || (_line130 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line131 || (_line131 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line132 || (_line132 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line133 || (_line133 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line134 || (_line134 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line135 || (_line135 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line136 || (_line136 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line137 || (_line137 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line138 || (_line138 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line139 || (_line139 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle61 || (_circle61 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle62 || (_circle62 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs62 || (_defs62 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000145023368890483134960000000421112714989855907_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000056418691609830207010000007758406127462342023_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000145023368890483134960000000421112714989855907_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000056418691609830207010000007758406127462342023_)"
    }
  }, _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle63 || (_circle63 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle64 || (_circle64 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs63 || (_defs63 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000005969757268962401360000006205735177769384320_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000134928196223302798380000006694353531599763636_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005969757268962401360000006205735177769384320_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000134928196223302798380000006694353531599763636_)"
    }
  }, _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle65 || (_circle65 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle66 || (_circle66 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs64 || (_defs64 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000141452932949762376650000016554600953786525076_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000145041539902903013050000017852546603991671707_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000141452932949762376650000016554600953786525076_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000145041539902903013050000017852546603991671707_)"
    }
  }, _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle67 || (_circle67 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle68 || (_circle68 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs65 || (_defs65 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000130610700785429876590000013708112342445200048_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000003099310051761645520000014956879935760022697_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000130610700785429876590000013708112342445200048_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000003099310051761645520000014956879935760022697_)"
    }
  }, _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle69 || (_circle69 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle70 || (_circle70 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs66 || (_defs66 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000175298974184270074300000011117845733204896902_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014592986808318932210000001648129458382516363_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175298974184270074300000011117845733204896902_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014592986808318932210000001648129458382516363_)"
    }
  }, _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs67 || (_defs67 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000085967676090400454940000018422891842189605527_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109026112010673064820000003228049081689739943_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000085967676090400454940000018422891842189605527_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109026112010673064820000003228049081689739943_)"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs68 || (_defs68 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000168107883276560455890000006909087602894718355_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000101091567889019447110000003823367598654055305_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000168107883276560455890000006909087602894718355_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000101091567889019447110000003823367598654055305_)"
    }
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs69 || (_defs69 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000051377184725134735330000016065731588681249982_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000170957830245394474240000014866129408442922426_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000051377184725134735330000016065731588681249982_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000170957830245394474240000014866129408442922426_)"
    }
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs70 || (_defs70 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000175299896672133665690000008689655878685622927_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000015336512423932705800000000919115493736626831_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000175299896672133665690000008689655878685622927_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000015336512423932705800000000919115493736626831_)"
    }
  }, _line140 || (_line140 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line141 || (_line141 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line142 || (_line142 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line143 || (_line143 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line144 || (_line144 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line145 || (_line145 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line146 || (_line146 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line147 || (_line147 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000110453626077620581420000016163205404536369049_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1_00000124163389316390738050000007886660280293460670_"
  }, _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "pansements_00000011028216224598397550000010239251735871770024_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,96.2c0.4-0.4,5.8-5.7,6.8-6.5c1-1.1,2.5-1.5,3.9-1.2c1.7,0.5,7.8,7.9,7.8,7.9s1.9,1.9,0.2,3.7 s-29.9,29.7-30.9,30.3s-5.1,1.8-6.6,0.6c-1.5-1.2-6.3-7.5-6.3-8.4s-0.8-3.1,1.5-5.3S170.2,96.2,170.2,96.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.5,114.8c0,0,3.9,4.6,4.3,4.8s1.4,1,2.1,0.7c0.7-0.3,14.5-13.6,14.8-14c0.3-0.7,0.3-1.5,0.2-2.3 c-1.3-1.7-2.9-3.3-4.6-4.7c-0.9-0.4-2-0.3-2.8,0.2c-0.6,0.6-12.5,12.6-12.9,12.9S156,114.1,156.5,114.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M148.2,101.2c0,0-2.7-2.2-2.1-4.2c0.6-1.9,3.9-4.8,3.9-4.8s3.9-3.2,5.7-3.7c1.8-0.5,4.7,2.2,6.2,3.3 s24,25.7,24.5,27.1c0.4,1.9-0.1,3.8-1.2,5.3c-1.4,1.9-3.2,3.5-5.3,4.6c-1.3,0.6-4.9,0.1-7-2.1 C170.6,124.5,148.2,101.2,148.2,101.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,105.7c0.9-0.9,5.7-5.6,6.2-5.8s3.3,1.4,3.8,1.9s6.8,7.6,7.3,8.4c0.5,1.1,0.5,2.3-0.1,3.3 c-0.5,0.5-3.9,3.5-4.8,4c-0.8,0.5-1.8,0.6-2.7,0.2c-0.8-0.4-9.3-8.9-9.6-9.4C157.3,107.5,157.3,106.6,157.5,105.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.6,99.3c-0.1-0.2,0.4-0.4,0.7-0.3c0.4,0.3,0.7,0.6,0.9,1.1c0.1,0.4,0,0.5-0.4,0.6C152.5,100.6,151.7,99.6,151.6,99.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.5,97c-0.2-0.4,0.5-0.5,0.9-0.3c0.3,0.2,0.5,0.4,0.7,0.8c0.1,0.2,0.3,0.2,0.2,0.6c-0.2,0.4-0.2,0.5-0.6,0.4 S154.7,97.3,154.5,97z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,94.1c-0.1-0.4,0.2-0.4,0.6-0.2s1.4,1,1.4,1.4c0,0.4-0.5,0.9-0.7,0.8C157.8,95.5,157.3,94.8,157,94.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.2,97.2c0-0.4,0.6,0,0.9,0.2c0.3,0.3,0.6,0.6,0.8,1c0.1,0.2,0.2,0.3-0.2,0.4c-0.4,0.1-0.7-0.1-0.9-0.4 C160.4,98.1,160.3,97.7,160.2,97.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.1,99.8c0.3-0.3,0.7,0.1,1,0.4c0.2,0.2,0.3,0.5,0.4,0.8c0.1,0.2-0.3,0.5-0.6,0.3c-0.3-0.2-0.5-0.4-0.8-0.7 C157.9,100.1,157.9,100,158.1,99.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.3,102.4c0.2-0.3,0.2-0.1,0.6,0.1c0.3,0.1,0.6,0.4,0.8,0.7c0.3,0.3,0.2,0.6,0.1,0.7c-0.3,0.1-0.6,0.1-0.9-0.1 C155.6,103.6,155.1,102.7,155.3,102.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.6,118.8c0.5,0.3,0.9,0.6,1.2,1c0.2,0.3,0.4,0.5,0,0.7s-0.4,0.1-0.8-0.2s-0.9-0.8-1-1.1S171.3,118.6,171.6,118.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.1,116.4c0-0.2,0.2-0.5,0.5-0.3c0.3,0.3,0.6,0.7,0.9,1.1c0.3,0.3,0.6,0.4,0.4,0.6s-0.7,0.6-0.8,0.4 C174.7,117.6,174.3,117,174.1,116.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,114.1c0.3-0.1,0.6,0.2,1,0.5s0.7,0.6,0.5,1s-0.6,0.6-0.7,0.4c-0.3-0.4-0.6-0.8-1-1.2 C176.3,114.6,176.2,114.2,176.7,114.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,117.7c0.2-0.2,0.2-0.3,0.6,0c0.4,0.3,0.7,0.7,1,1.2c0.2,0.3,0.1,0.5-0.1,0.6c-0.2,0.1-0.5,0-0.6-0.2 c-0.1-0.2-1.1-0.9-1.1-1.1S179.9,117.7,179.9,117.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177,120.1c0.2-0.2,0.2-0.4,0.5-0.2c0.4,0.4,0.8,0.8,1.1,1.2c0.2,0.3,0.3,0.6,0.1,0.7c-0.2,0-0.4,0-0.6,0 C178,121.8,176.7,120.5,177,120.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.4,122.3c0.2-0.2,0.3-0.2,0.7,0.1s0.5,0.5,0.8,0.8s0.5,0.4,0.3,0.6s-0.4,0.1-0.7,0.1s-1.1-1-1.2-1.2 S174.2,122.5,174.4,122.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.5,115.8c-0.7,0.2-1.2,0.6-1.5,1.2c-0.1,0.4,0,0.6,0.2,0.6c0.2,0,0.4-0.1,0.8-0.4c0.3-0.3,0.6-0.5,0.9-0.8 C154,116.2,153.9,115.8,153.5,115.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.9,119.6c-0.5,0.1-0.9,0.3-1.1,0.7c-0.2,0.2-0.4,0.2-0.3,0.5s0.1,0.5,0.4,0.4c0.4-0.2,0.8-0.5,1.2-0.8 C157.3,120.3,157.5,119.6,156.9,119.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.9,122.6c-0.6-0.1-1.3,0.7-1.4,1c-0.1,0.3-0.1,1,0.2,0.9c0.4-0.2,0.7-0.4,1.1-0.7c0.4-0.3,0.3-0.3,0.5-0.6 C160.5,123,160.3,122.6,159.9,122.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,125.4c-0.4,0-1.3,0.8-1.4,1c-0.2,0.2-0.3,0.5-0.2,0.7s0.8-0.1,0.8-0.1s0.8-0.8,1.1-1S156.4,125.5,156,125.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.6,122.4c-0.3-0.1-1.6,0.7-1.6,1.1s0.1,0.8,0.4,0.7c0.4-0.3,0.9-0.6,1.3-0.9C153,123,153,122.5,152.6,122.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,118.9c-0.4,0.1-1.6,0.9-1.7,1.2c0,0.3-0.1,0.5,0.2,0.5c0.4,0,0.9-0.2,1.2-0.6c0.2-0.3,0.7-0.3,0.7-0.7 c0.1-0.2,0-0.4-0.2-0.5C149.7,118.8,149.7,118.8,149.6,118.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.3,95.6c-0.2-0.1-0.9,0.6-1.1,1s-0.5,0.9-0.1,0.8c0.3-0.1,0.6-0.2,0.9-0.4c0.3-0.3,0.6-0.5,0.8-0.8 C176,96,175.5,95.7,175.3,95.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,95.9c-0.4,0-1,0.8-1.1,1.1s-0.2,0.6,0,0.7c0.2,0.1,0.5,0,0.6-0.2l0.6-0.6c0,0,0.8-0.5,0.6-0.8S182.3,95.9,182,95.9z "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.1,98.4c-0.2,0.1-1,0.6-1.1,0.9c-0.1,0.2-0.1,0.5,0,0.7l0.8-0.3l0.7-0.6C185.4,99.1,185.8,98.1,185.1,98.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.1,102c-0.3,0-0.7,0.5-1.1,0.9s-0.6,0.8-0.2,0.8s0.4,0,0.8-0.3c0.2-0.2,0.4-0.4,0.6-0.6 C182.4,102.4,182.3,102,182.1,102z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.2,99c-0.4,0.2-1.1,0.6-1.2,0.9s-0.4,0.7,0.1,0.5c0.4-0.2,0.7-0.4,1-0.6l0.6-0.5C179.7,99.4,179.5,98.9,179.2,99z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "seringue_00000034782017806167048110000000735814083743558058_"
  }, _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    points: "191.6,195.5 181.8,184 177.1,188.8 186.7,199.5  "
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "103.2,107.5 126,132.4 127.5,130.9 104.4,105.3  "
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    points: "122.9,134.6 131.4,126.8 137,133.6 127.5,140.5  "
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "123.1,143.6 141.8,127.8 187.1,175.6 167.1,190.1  "
  })), /*#__PURE__*/React.createElement("g", null, _defs71 || (_defs71 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_00000023972031798866379630000017781874802052665493_",
    points: "123.1,143.6 141.8,127.8 187.1,175.6  167.2,190.1  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122707227781242750330000004832310716623626132_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000023972031798866379630000017781874802052665493_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122707227781242750330000004832310716623626132_)"
    }
  }, _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "149.2,168 168.4,150.9 143.4,125.2 119.7,145.7 138.6,167.1 144.2,173.3  "
  })), _line148 || (_line148 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 133.9,
    y1: 138,
    x2: 124.3,
    y2: 146.3
  })), _line149 || (_line149 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 147.2,
    x2: 132.4,
    y2: 155.4
  })), _line150 || (_line150 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 149.4,
    y1: 156.2,
    x2: 139.2,
    y2: 164.7
  })), _line151 || (_line151 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 157.8,
    y1: 164.6,
    x2: 147.5,
    y2: 173.2
  })), _line152 || (_line152 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 166.4,
    y1: 173.3,
    x2: 155.8,
    y2: 182
  })), _line153 || (_line153 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 132.6,
    y1: 144.5,
    x2: 127.7,
    y2: 148.6
  })), _line154 || (_line154 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 134.9,
    y1: 148,
    x2: 130.6,
    y2: 151.6
  })), _line155 || (_line155 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 140,
    y1: 153.7,
    x2: 135.7,
    y2: 158
  })), _line156 || (_line156 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 142.1,
    y1: 156,
    x2: 138.1,
    y2: 160.7
  })), _line157 || (_line157 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 148.5,
    y1: 162.1,
    x2: 142.8,
    y2: 166.8
  })), _line158 || (_line158 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 150.4,
    y1: 164.4,
    x2: 145.4,
    y2: 169.5
  })), _line159 || (_line159 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 155.5,
    y1: 170.9,
    x2: 150.6,
    y2: 175.1
  })), _line160 || (_line160 = /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 158.6,
    y1: 173.3,
    x2: 153.7,
    y2: 177.4
  })))), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "189,171.9 193.1,177 168.8,197.6 164.8,192.1  "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M196.6,190.4l4,4.3c0,0-13.6,13-13.8,12.4s-4.6-4.7-4.6-4.7L196.6,190.4z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M146.6,146.3c-0.5,0.3-0.9,0.6-1.3,1c-0.1,0.2-0.4,0.5,0.1,0.4c0.5-0.1,0.5-0.2,0.8-0.4c0.3-0.2,0.5-0.4,0.8-0.6 C147.2,146.5,146.8,146.2,146.6,146.3z"
  }))), _circle71 || (_circle71 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 100.8,
    cy: 90.6,
    r: 26.9
  })), _circle72 || (_circle72 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 99,
    cy: 85.5,
    r: 26.9
  })), /*#__PURE__*/React.createElement("g", null, _defs72 || (_defs72 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000003075137718856312590000013476611574128946320_",
    cx: 99,
    cy: 85.5,
    r: 26.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000026149680151907714690000012669562782955503273_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000003075137718856312590000013476611574128946320_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000026149680151907714690000012669562782955503273_)"
    }
  }, _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 70.4,
    y: 83.1,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -21.2547 33.8209)",
    className: "st9",
    width: 57.9,
    height: 5.9
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: -1226.9,
    y: 80.5,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -80.7648 -355.9099)",
    className: "st12",
    width: 57.9,
    height: 8.5
  })))), _circle73 || (_circle73 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 53.9,
    cy: 63.7,
    r: 10.8
  })), _circle74 || (_circle74 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs73 || (_defs73 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000119120159951815606960000013218940508701735585_",
    cx: 52.6,
    cy: 61.9,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000039105837470520571940000006591056221549994131_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000119120159951815606960000013218940508701735585_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000039105837470520571940000006591056221549994131_)"
    }
  }, _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 41.3,
    y: 60.9,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -26.0019 41.2771)",
    className: "st9",
    width: 23.1,
    height: 2.4
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: -454.2,
    y: 214.4,
    transform: "matrix(0.821 -0.5709 0.5709 0.821 -202.5815 -213.9697)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle75 || (_circle75 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 77.9,
    cy: 39.9,
    r: 10.8
  })), _circle76 || (_circle76 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs74 || (_defs74 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000005253404440882171140000012123600385688096904_",
    cx: 79.1,
    cy: 38.1,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000025432485426385620700000009476754825201530521_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000005253404440882171140000012123600385688096904_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000025432485426385620700000009476754825201530521_)"
    }
  }, _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 77.8,
    y: 26.8,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 2.0468 80.7251)",
    className: "st9",
    width: 2.4,
    height: 23.2
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: -236.2,
    y: -386.5,
    transform: "matrix(0.5776 -0.8163 0.8163 0.5776 207.0409 -349.8411)",
    className: "st12",
    width: 3.4,
    height: 23.1
  })))), _circle77 || (_circle77 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 112.1,
    cy: 38.8,
    r: 10.8
  })), _circle78 || (_circle78 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs75 || (_defs75 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000111879983976762952190000016825707487773786755_",
    cx: 111.4,
    cy: 36.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000031908235740749378940000006232251203214654874_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000111879983976762952190000016825707487773786755_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000031908235740749378940000006232251203214654874_)"
    }
  }, _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 99.9,
    y: 35.8,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -5.9508 35.2045)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: -418.9,
    y: 34.7,
    transform: "matrix(0.9538 -0.3004 0.3004 0.9538 -29.7526 -120.6598)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _circle79 || (_circle79 = /*#__PURE__*/React.createElement("circle", {
    className: "st9",
    cx: 139.1,
    cy: 57.5,
    r: 10.8
  })), _circle80 || (_circle80 = /*#__PURE__*/React.createElement("circle", {
    className: "st10",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  })), /*#__PURE__*/React.createElement("g", null, _defs76 || (_defs76 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "SVGID_00000129180233685306803610000009150434778800439716_",
    cx: 137.1,
    cy: 56.7,
    r: 10.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080924887632762676460000016550287507273262490_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000129180233685306803610000009150434778800439716_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000080924887632762676460000016550287507273262490_)"
    }
  }, _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 125.8,
    y: 55.5,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 29.0518 158.4586)",
    className: "st9",
    width: 23.2,
    height: 2.4
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: -220.7,
    y: 441.2,
    transform: "matrix(0.4126 -0.9109 0.9109 0.4126 -526.2467 69.6091)",
    className: "st12",
    width: 23.1,
    height: 3.4
  })))), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1 s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7C100.3,143.8,97.1,142.1,93.9,142.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs77 || (_defs77 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000093163785119344563730000012755947801316545211_",
    d: "M93.9,142.8c0,0-2.7,0.4-3.8,2.1S84,164.3,84,164.3 s-1.9,7.8-1.1,10.1c0.8,2.3,3.6,5.1,5.7,5.1s3,1.3,5.7-2.7c2.7-4,5.9-20.2,5.9-20.2s2.1-7,1.3-9.7 C100.3,143.8,97.1,142.1,93.9,142.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000014593948136827581730000000254491317061306528_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000093163785119344563730000012755947801316545211_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000014593948136827581730000000254491317061306528_)"
    }
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M84.3,159.3c0,0,5.3,0.4,7,0.6c1.7,0.2,6.5,2.7,6.5,2.7l3,2.5l4.1-7.7l0.8-10.1l-4.4-9.1L91,137.9l-8.4,5.5 l-4.2,13.5L84.3,159.3z"
  })))), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1 s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  })), /*#__PURE__*/React.createElement("g", null, _defs78 || (_defs78 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174580647115959760100000005697711385276694194_",
    d: "M100.8,169.8c0,0,0,2.8,1.5,4.1s18.2,9.1,18.2,9.1 s7.4,3.1,9.8,2.6s5.6-2.8,5.9-4.8s1.7-2.7-1.8-6.1s-19.1-9-19.1-9s-6.5-3.2-9.4-2.8S100.5,166.8,100.8,169.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000122711622902424368370000010009937895522890906_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174580647115959760100000005697711385276694194_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000122711622902424368370000010009937895522890906_)"
    }
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M115.7,181.9c0,0,1.2-5.1,1.7-6.8s3.7-6,3.7-6l3-2.5l-7-5.3l-9.9-2.4l-9.6,3l-2,10.1l4.1,9.2l12.7,6.3 L115.7,181.9z"
  })))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1 s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  })), /*#__PURE__*/React.createElement("g", null, _defs79 || (_defs79 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000078765007261000541630000017442800672122462348_",
    d: "M42.2,122.1c-1.2,0.3-5.2,3.5-5.7,6.7 c-0.5,3.1-0.1,38.8,0.3,39.8c0.4,0.9,1,2.9,2.5,3.3s8.5,3.5,12.6,3.1s8.3-0.8,11.5-2.2c3.3-1.3,5-5.7,5.3-7.1 s-0.4-37.7-0.8-39.3c-0.4-1.6-5.3-6.1-8.3-5.7C56.5,121,42.2,122.1,42.2,122.1z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000040539963517166286250000012288102795276834469_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000078765007261000541630000017442800672122462348_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000040539963517166286250000012288102795276834469_)"
    }
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M34.8,135.4l6.8,3.4c0,0,13.6,2.4,15.5,1.9c1.9-0.5,8.7-1.5,9.7-2.3s3.8-2.5,3.8-2.5v24.3l-7.8,3.3 c0,0-13.3,1.7-16.3,1.4c-3-0.4-11.2-4.5-11.6-4.8S34.8,135.4,34.8,135.4z"
  })))), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5 c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4s-5.7-1.4-5.9-1.8 C42.4,115.3,42.1,115.1,41.8,115.2z"
  })), /*#__PURE__*/React.createElement("g", null, _defs80 || (_defs80 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000029757442834229641760000011744543809809029310_",
    d: "M41.8,115.2l0.4,6.9c0.7,0.9,1.6,1.7,2.5,2.3 c0.8,0.4,8.2,1.4,8.2,1.4s4.9-0.8,6.2-1.5c1.3-0.9,2.4-1.9,3.5-3l-0.3-7.2c-1.4,1.1-2.8,2.1-4.2,3c-1.1,0.5-8.8,0.4-9.7,0.4 s-5.7-1.4-5.9-1.8C42.4,115.3,42.1,115.1,41.8,115.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000064341920400041612600000001989143019093448854_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000029757442834229641760000011744543809809029310_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000064341920400041612600000001989143019093448854_)"
    }
  }, _line161 || (_line161 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 44.3,
    y1: 115.3,
    x2: 44.1,
    y2: 125.4
  })), _line162 || (_line162 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 46.5,
    y1: 116.2,
    x2: 45.9,
    y2: 126
  })), _line163 || (_line163 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 48.3,
    y1: 116.2,
    x2: 48.1,
    y2: 126.4
  })), _line164 || (_line164 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 50.9,
    y1: 116.5,
    x2: 50.6,
    y2: 126.8
  })), _line165 || (_line165 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 52.6,
    y1: 116.4,
    x2: 52.5,
    y2: 126.8
  })), _line166 || (_line166 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 55,
    y1: 116.2,
    x2: 55.1,
    y2: 126.6
  })), _line167 || (_line167 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 57.6,
    y1: 115.9,
    x2: 57.7,
    y2: 125.9
  })), _line168 || (_line168 = /*#__PURE__*/React.createElement("line", {
    className: "st25",
    x1: 59.6,
    y1: 115,
    x2: 60.4,
    y2: 124.4
  })))), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "st26",
    points: "49.3,145.4 54.4,145.5 55,150.6 58.7,150.3 58.6,155.3 54.2,155.9 53.8,159.4 47.1,159 46.9,154.5  43.3,154.8 43.7,148.4 48.5,149.4  "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M54.1,111.3c-2.8-0.3-9.1,0.8-10,1c-0.9,0.2-2.5,2-2.3,2.8c0.9,1.2,2.2,2,3.6,2.4c0.9,0,9.8,0.6,9.8,0.6 c2.1-0.6,4.1-1.4,6.1-2.3c0.6-0.4,1-1.2,1-1.9C62.3,112.8,56.9,111.6,54.1,111.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCause1);
export default __webpack_public_path__ + "static/media/cause_1.641313f9d80f35b69b89c34fad5b04db.svg";
export { ForwardRef as ReactComponent };